import { useEffect, useRef, useState } from "react";

export const useStableQueryData = (query, fallbackData) => {
    const [stableData, setStableData] = useState(() => query.data ?? fallbackData);
    const hasStableDataRef = useRef(query.data !== undefined);
    const hasCurrentData = query.data !== undefined && !query.isPreviousData;

    useEffect(() => {
        if (!hasCurrentData) {
            return;
        }

        setStableData(query.data);
        hasStableDataRef.current = true;
    }, [hasCurrentData, query.data]);

    const hasStableData = hasCurrentData || hasStableDataRef.current;

    return {
        data: hasCurrentData ? query.data : hasStableData ? stableData : fallbackData,
        hasData: hasStableData,
        isLoading: (query.isLoading || query.isFetching) && !hasStableData,
        isRefreshing: query.isFetching && hasStableData,
    };
};
